import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { attachServiceWorkerUpdates } from './utils/serviceWorkerUpdate';
// Depois do App, de propósito: tem de vir por último na cascata para vencer os estilos dele.
import './responsivo-movel.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registar Service Worker para PWA — só em produção. Em desenvolvimento, um service worker a servir o
// shell da cache esconde as alterações e obriga a limpar caches à mão: o dev server fica sem ele.
//
// A versão nova já não entra sozinha (o sw.js deixou de chamar skipWaiting ao instalar): fica em espera
// e a app mostra a faixa «Nova versão do GyMag disponível» com «Atualizar» (components/Pwa/UpdateBanner).
// Aqui só se liga o registo ao aviso e à verificação periódica — ao arrancar, ao voltar à app e de 30
// em 30 minutos. Aplicar a versão é recarregar a página: a sessão (token no localStorage) mantém-se.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        attachServiceWorkerUpdates(registration);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// A permissão de notificações NÃO se pede à entrada da app: só quando o atleta liga os lembretes de
// treino nas definições (ver components/Pwa/TrainingReminderSettings). Pedi-la sem contexto é a
// melhor forma de a ver recusada — e depois já não se pode voltar a pedir.
